module.exports = __webpack_public_path__ + "img/publicusericonnew.034547f7.png";